// Installed collection apps share one content grid in a route or PageSlot.
// The host keeps window controls; the app supplies its heading and actions.
//
// ONE SCROLLER PER PAGE (Nika 2026-10-27: "header takes too much space and
// there is small space left for content scroll. use full page scroll and do
// not make inside overflow for pageslot contents"). AppMain is the page's one
// scroller: the header scrolls away with the records, and the Body grows with
// its content instead of scrolling inside itself. Measured on dev before the
// change (kestrel-assist, 1920x873 window): the pane gave the CRM board 621 of
// 747 px under a fixed 126 px header, Production 538 under 209. After it the
// whole 747 px pane scrolls as one page.
//
// AppMain, not the page root, because the root also holds the app's rail
// (AppCollectionSidebar): the rail stays in view beside the scrolling page
// and needs no sticky positioning. The root never overflows — the route
// mount's own `overflow: auto` (workspace app.js) and the PageSlot host's
// stay idle. AppMain is no stacking context (no z-index, transform or
// filter), so a fixed dialog or toast inside it is never clipped to it on
// iOS (the PageSlot host's iOS fixed-layer rule).
//
// An app page restates none of this: no `overflow`, `flex` or `minHeight` on
// its Body (apps/tests/appScrollContract.test.js). A data region that must
// scroll SIDEWAYS (a kanban, a wide table) keeps its own `overflowX`.
export const AppCollectionPage = {
  extends: 'AppPage',
  height: '100%',
  minHeight: '0',
  position: 'relative',
  // Reserve the rail's position without creating one for apps that omit it.
  AppSidebar: null,
  AppMain: {
    margin: '0',
    // x hidden keeps the rounded sheet's edge; y auto makes it the scroller
    overflow: 'hidden auto',
    overscrollBehavior: 'contain',
    '@mobileL': { margin: '0' },
    '@appMobile': { margin: '0' },
    // frank-allow FA806 — AppMain owns this existing Header slot
    Header: {
      extends: 'PageHeader',
      // It scrolls with the page: a sticky bar would keep the same height off
      // the records on every scroll position.
      position: 'static',
      // Compact (the same request): the window bar above already names the
      // app, so the header keeps one step under the bar and a half step over
      // the Body.
      padding: 'Z B Y',
      gap: 'Z',
      align: 'flex-end space-between',
      '@mobileL': { padding: 'Z A Y' },
      '@appMobile': { padding: 'Z A Y' },
      LeftGroup: {
        flow: 'y',
        align: 'flex-start flex-start',
        gap: 'Y'
      }
    },
    Body: {
      margin: '0',
      padding: 'Z B B',
      gap: 'B',
      boxSizing: 'border-box',
      // Grows with its records (never shrinks below them) and fills a short
      // page; AppMain scrolls it.
      flex: '1 0 auto',
      overflow: 'visible',
      '@mobileL': { padding: 'Z A A' },
      '@appMobile': { padding: 'Z A A' }
    }
  }
}
